import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { xScrollInjextionKey as x } from "./context.js";
import { FinweckTree as v } from "../../shared/finweck-tree.js";
import u from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/use-memo.js";
import { ref as i } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { computed as h, provide as w } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
function R({ columnsRef: n, renderColRef: c, renderItemWithColsRef: s }) {
  const l = i(0), r = i(0), o = h(() => {
    const e = n.value;
    if (e.length === 0)
      return null;
    const t = new v(e.length, 0);
    return e.forEach((d, p) => {
      t.add(p, d.width);
    }), t;
  }), f = u(() => {
    const e = o.value;
    return e !== null ? Math.max(e.getBound(r.value) - 1, 0) : 0;
  }), m = (e) => {
    const t = o.value;
    return t !== null ? t.sum(e) : 0;
  }, a = u(() => {
    const e = o.value;
    return e !== null ? Math.min(e.getBound(r.value + l.value) + 1, n.value.length - 1) : 0;
  });
  return w(x, {
    startIndexRef: f,
    endIndexRef: a,
    columnsRef: n,
    renderColRef: c,
    renderItemWithColsRef: s,
    getLeft: m
  }), {
    listWidthRef: l,
    scrollLeftRef: r
  };
}
export {
  R as setupXScroll
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/vueuc@0.4.64_vue@3.5.18/~/vueuc/es/virtual-list/src/xScroll.js
// module id = 1790
// module chunks = 67